import { getOrderTotals } from '../../orders/hooks/useOrderTotals/order-totals.repository';
import { OrderListTotals } from '../../orders/hooks/useOrderTotals/order-totals.types';
import { StatusType } from '../../orders/order.types';
import { offlineOrdersRepository } from '../repositories/offlineOrders.repository';
import { createApiSauceResponse } from '../utils/createApiSauceResponse.util';

const offlineGetOrderTotals = async (): ReturnType<typeof getOrderTotals> => {
  const allOrders = await offlineOrdersRepository.getAll();
  const total = allOrders.reduce((acc, order) => acc + order.subTotal, 0);
  const totalPieces = allOrders.reduce((acc, order) => acc + order.totalPieces, 0);
  const data: OrderListTotals = {
    totalDiscountValue: 0,
    totalGrossValue: total,
    totalNetValue: total,
    totalPieces: totalPieces,
    totalOrders: allOrders.length,
    orderStatus: StatusType.DRAFT,
    totalChargesValue: 0,
    totalShippingCostValue: 0,
    totalItemsGrossValue: 0,
    totalItemsDiscountValue: 0,
  };

  return createApiSauceResponse<OrderListTotals[]>({
    ok: true,
    data: [data],
  });
};

export const orderTotalsRepositoryOfflineAdapters = {
  getOrderTotals: offlineGetOrderTotals,
};
